import { Typography } from "@mui/material"
import { translate } from "app/language/service"
import { IRootState } from "app/model"
import { GEO_TARGETS_FORM_TABS, GEO_TARGETS_FORM_WIDTH, IGeoTargetsForm } from "form/model"
import { getGeoTargetsFormSafely } from "form/tools/geo-targets"
import React from "react"
import { connect } from "react-redux"
import { FlexBox } from "ui/components/FlexBox"
import { GeoTargetsCoordinateForm } from "./GeoTargetsCoordinateForm"
import { GeoTargetsShapeForm } from "./GeoTargetsShapeForm"
import { GeoTargetsTabs } from "./GeoTargetsTabs"

interface IGeoTargetsFormProps {
  geoTargetsForm: IGeoTargetsForm | null
  isTightContent: boolean
}

const GeoTargetsFormFn = React.memo(({ geoTargetsForm, isTightContent }: IGeoTargetsFormProps) =>
  geoTargetsForm === null ? null : (
    <FlexBox
      jc="start"
      vertical
      sx={{
        width: isTightContent ? "100%" : GEO_TARGETS_FORM_WIDTH,
        height: isTightContent ? undefined : "100%",
        gap: ".5rem"
      }}>
      <Typography id="geo-target-title" color="textPrimary" fontSize=".85rem" width="100%">
        {translate("campaign.geo-targets.form.title")}
      </Typography>
      <GeoTargetsTabs />
      {geoTargetsForm.activeTab === GEO_TARGETS_FORM_TABS.SHAPE ? (
        <GeoTargetsShapeForm geoTargetsForm={geoTargetsForm} />
      ) : (
        <GeoTargetsCoordinateForm geoTargetsForm={geoTargetsForm} />
      )}
    </FlexBox>
  )
)

export const GeoTargetsForm = connect(
  (state: IRootState): IGeoTargetsFormProps => ({
    geoTargetsForm: getGeoTargetsFormSafely(state),
    isTightContent: state.ui.contentWidth < 760
  })
)(GeoTargetsFormFn)
